import { request } from '@/plugins/plugin-request';
// 推荐申请角色列表
export function getApplyRoleList(params) {
  return request
    .get({
      url: 'common.getRolesByNodeId',
      params,
    })
    .then((res) => res.data);
}
// 设置最近访问历史
export function setRecentVisit(params) {
  return request
    .post({
      url: 'common.setUserRecentVisit',
      params,
    })
    .then((res) => res.data);
}
